<template>
  <div>
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">基金组合买入</span>
        <Reback class="row-one-fr" @click.native="returnOne"></Reback>
        <span class="row-one-fr" @click="detailsClick">查看资产详情</span>
      </el-row>
      <!-- 表单 -->
      <el-form v-show="stepDisplay == '1'" :model="combinationBuyForm" :rules="combinationBuyFormRules" ref="combinationBuyFormRef" label-width="100px" label-position="right" class="form-single">
        <!-- 组合名称 -->
        <el-form-item label="组合名称：">
          <el-radio-group v-model="combinationBuyForm.type" class="margin-t5 lh35" @change="comNameChange">
            <el-radio :label="'ZHZ001'">公募组合(保守型)</el-radio>
            <el-radio :label="'ZHZ002'">公募组合(稳健型)</el-radio>
            <el-radio :label="'ZHZ003'">公募组合(平衡型)</el-radio>
            <el-radio :label="'ZH0034'">公募组合(成长型)</el-radio>
            <el-radio :label="'ZHZ000'">公募组合(进取型)</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 购买金额 -->
        <el-form-item label="购买金额：" prop="money">
          <el-input v-model="combinationBuyForm.money" @input="combinationBuyInput" @blur="combinationBuyBlur" :placeholder="(this.combinationBuyForm.type == 'ZH0034' || this.combinationBuyForm.type == 'ZHZ000')?'3000元起':'1000元起'">
            <span slot="suffix" class="form-single-suf">元</span>
          </el-input>
          <div v-show="rateShow" class="el-form-item__error warnColor">{{'预计费率：'+rate+'% 预计费用：'+cost}}</div>
        </el-form-item>
        <!-- 支付方式 -->
        <el-form-item label="支付方式：" class="margin-t25">
          <span class="form-single-sp" style="color:#246EAD;">银行卡支付</span>
        </el-form-item>
        <!-- 银行卡列表 -->
        <el-form-item class="selectTwo" prop="card">
          <BankCardList :v-model="combinationBuyForm.card" @slected="getslectedValue" @func="getslectedValue"></BankCardList>
          <span v-if=" combinationBuyForm.card ==''" class="form-single-all" @click="$router.push({name:'accountManagement',params:{active:'2'}})">去添加</span>
          <div v-show="combinationBuyForm.card != ''" class="el-form-item__error warnColor">{{'单笔'+SingleDealLimit+'，单日'+SingleDayLimit}}</div>
        </el-form-item>
        <!-- 卡券抵扣 -->
        <el-form-item label="卡券抵扣：">
          <el-radio-group v-model="combinationBuyForm.coupon" @change="couponChange">
            <el-radio :label="1">立减券(可叠加)</el-radio>
            <el-radio :label="2">满减券</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 优惠券 -->
        <el-form-item class="margin-t-15">
          <ReduceCoupon v-if="combinationBuyForm.coupon==1" @reduceCouponChange="reduceCouponChange"></ReduceCoupon>
          <FullReduceCoupon v-else @fullReduceCouponChange="fullReduceCouponChange"></FullReduceCoupon>
          <span class="form-single-all" @click="$router.push({name:'pointsExchange',params:{pathName:'combinationBuy'}})">去兑换</span>
        </el-form-item>
        <!-- 实付金额 -->
        <el-form-item label="实付金额：" class="margin-t-15" prop="actuallyPaid">
          <span class="form-single-sp">{{combinationBuyForm.actuallyPaid}}元</span>
          <span class="margin-l50 warnColor">优惠券已抵扣{{reduceMoney}}</span>
          <p v-show="waste" class="form-single-tips rColor">{{wasteText}}</p>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item label="密码：" prop="pass" :error="errorMsg">
          <el-input v-model="combinationBuyForm.pass" type="password" show-password></el-input>
          <el-input style="position:fixed;bottom:-9999px;"></el-input>
        </el-form-item>
        <el-form-item prop="checked" label-width="100px">
          <div class="read">
            <el-checkbox class="checkbox-one" v-model="combinationBuyForm.checked">
            </el-checkbox>
            <span class="margin-l10">请阅读并同意</span>
            <span class="aColor" style="cursor: pointer;" @click="severClick">《精准理财服务协议》</span>,
            <span class="aColor" style="cursor: pointer;" @click="dialogVisable2 = true">组合相关基金协议</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="normal" @click="purchaseClick" :disabled="purchaseText == '处理中...'">{{purchaseText}}</el-button>
          <el-button type="cancel" class="fr" @click="returnOne">返回</el-button>
        </el-form-item>
      </el-form>
      <!-- 成功页面 -->
      <section class="xDetail" v-show="stepDisplay == '2'">
        <div class="xDetail-icon">
          <img src="../../../assets/images/hbb/bigRight_230210309.png" width="40" alt="">
        </div>
        <p class="xDetail-title gColor">购买成功</p>
        <hr class="xDetail-hr">
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>申请单编号：</span><span>{{comappsheetno}}</span></li>
          <li class="xDetail-ul-li"><span>产品名称：</span><span>{{funddesc}}</span></li>
          <li class="xDetail-ul-li"><span>购买金额：</span><span>{{combinationBuyForm.money}}</span></li>
          <li class="xDetail-ul-li"><span>金额大写：</span><span id="capital"></span></li>
        </ul>
        <hr class="xDetail-hr">
        <div class="xDetail-footer">
          <el-button type="back" @click="returnOne">返回</el-button>
        </div>
      </section>
      <!-- 失败页面 -->
      <section class="xDetail" v-show="stepDisplay == '3'">
        <div class="xDetail-icon">
          <img src="../../../assets/images/hbb/error_20210309.png" width="40" alt="">
        </div>
        <p class="xDetail-title rColor">支付失败</p>
        <hr class="xDetail-hr">
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>失败原因：</span><span>{{wrongReason}}</span></li>
        </ul>
        <hr class="xDetail-hr">
        <div class="xDetail-footer">
          <el-button type="normal" @click="returnOne">确定</el-button>
        </div>
      </section>
    </div>
    <!--风险提示-->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable">
      <div class="dialog-single-three-p">风险提示</div>
      <p class="riskText">{{'经核实，您申请购买的产品风险等级为'+this.$commonJs.getcomLevel(combinationBuyForm.type)+'，您当前的风险等级为'+userRisk+'，适合您投资的产品最高风险等级为'+this.$commonJs.getcomLevel(this.$commonJs.getCookie('u_risk'))+'。根据适当性匹配原则，该产品高于您的风险承受能力。继续购买代表您已完全知悉该产品的风险并自愿承担后续决策风险。购买过程中销售机构未对您进行主动推介，特此确认。'}}</p>
      <div class="margin-t30">
        <el-button type="back" style="width:154px" @click="dialogVisable = false">取消</el-button>
        <el-button type="normal" style="width:154px" @click="riskFlag=false;dialogVisable = false">继续购买</el-button>
      </div>
    </el-dialog>
    <!-- 完善信息 -->
    <Perfect></Perfect>
    <!-- 风险测评 -->
    <RiskTips @func="getFunc"></RiskTips>
    <!-- 组合相关基金协议 -->
    <el-dialog class="dialog-single-two" :visible.sync="dialogVisable2">
      <div v-for="(item,i) in agreementLists" :key="i+'xy'" class="margin-t20">
        <div>{{item.fundname}}:</div>
        <div class="aColor margin-t10" style="text-align:center;">
          <a class="aColor" :href="'https://www.myfund.com/mutualfund/'+ item.fundcode +'.html?type=6&notice=基金合同'" target="blank">基金合同</a>、
          <a class="aColor" :href="'https://www.myfund.com/mutualfund/'+ item.fundcode +'.html?type=6&notice=招募说明书'" target="blank">招募说明书</a>、
          <a class="aColor" :href="'https://www.myfund.com/mutualfund/'+ item.fundcode +'.html?type=7'" target="blank">产品资料概要</a>、
          <a class="aColor" style="cursor: pointer;" @click="agreementClick(item.fundcode,'riskDisclosure')">风险揭示书</a>、
          <a class="aColor" style="cursor: pointer;" @click="agreementClick(item.fundcode,'customerMaintenanceFee')">客户维护费揭示书</a>
        </div>
      </div>
    </el-dialog>
    <!-- 暂停买入 -->
    <el-dialog class="dialog-single-two" :visible.sync="dialogVisable3" :show-close="false" :close-on-click-modal="false">
      <div class="dialog-single-three-p">基金组合暂停买入通知</div>
      <div class="margin-t30" style="color:#333;font-size: 16px;">
        <p style="margin-top: 20px;">根据最新法规和相关监管要求，我们将对精准理财进行规范调整。即日起，暂停基金组合的买入、调仓功能，组合赎回正常。已买入的组合可继续持有。</p>
        <p style="margin-top: 20px;">请您关注后续调整情况，及时做好投资安排。由此带来的不便，敬请谅解!</p>
      </div>
      <div class="margin-t30" style="text-align:center;">
        <el-button type="normal1" style="width:154px" @click="$router.push({name:'myAssets'})">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    const isNum = (rule, value, callback) => {
      const ret = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (this.combinationBuyForm.type == "ZH0034" || this.combinationBuyForm.type == "ZHZ000") {
        if (value < 3000) {
          callback(new Error('最低买入金额是3000元，请重新填写！'))
        } else if (value > parseFloat(this.SingleDealLimit)) {
          callback(new Error('您输入的金额超过银行卡单笔限额！'))
        } else if (!ret.test(value)) {
          callback(new Error('买入金额小数点位数不应超过2位，请重新填写！'))
        } else {
          callback()
        }
      } else {
        if (value < 1000) {
          callback(new Error('最低买入金额是1000元，请重新填写！'))
        } else if (value > parseFloat(this.SingleDealLimit)) {
          callback(new Error('您输入的金额超过银行卡单笔限额！'))
        } else if (!ret.test(value)) {
          callback(new Error('买入金额小数点位数不应超过2位，请重新填写！'))
        } else {
          callback()
        }
      }

    }
    return {
      dialogVisable: false,
      stepDisplay: '1',
      combinationBuyForm: {
        type: 'ZHZ001',
        money: '',
        card: '',
        coupon: 1,
        actuallyPaid: 0,
        pass: '',
        checked: false,
      },
      wrongReason: '',
      errorMsg: '',
      purchaseText: '确认购买',

      combinationBuyFormRules: {
        money: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { validator: isNum, trigger: 'blur' }
        ],
        card: [
          { required: true, message: '请选择银行卡', trigger: 'change' },
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        checked: [
          { required: true, message: '请选中', trigger: 'blur' }
        ]
      },
      waste: false, // 浪费提醒
      reduceMoney: 0,//抵扣金额
      minFull: '',
      wasteText: '使用优惠券造成金额浪费啦！',
      curAssetgroupArr: [],
      curAssetTansnArr: [],
      funddesc: '',//公募名称

      ticketidStr: '',// 优惠券id(,隔开)
      comappsheetno: '',//单号
      liqdate: '',
      specification: '',
      specitimeress: '',
      transactiondate: '',

      successFlag: false,
      userRisk: '',
      riskFlag: true,
      // 限额
      SingleDealLimit: '',
      SingleDayLimit: '',
      // 费率
      rate: '',
      cost: '0.00',
      rateShow: true,
      memberFlag: '',
      // 组合相关协议
      agreementLists: [],
      dialogVisable2: false,
      dialogVisable3: true,// 组合停止
      hfFlag: false,// 汇付
    }
  },
  created () {
    this.combinationBuyForm.type = this.$route.params.fundcode ? this.$commonJs.getCom(this.$route.params.fundcode) : 'ZHZ001';
    if (window.sessionStorage.getItem('deal') != null) {
      this.SingleDealLimit = window.sessionStorage.getItem('deal')
    }
    if (window.sessionStorage.getItem('day') != null) {
      this.SingleDayLimit = window.sessionStorage.getItem('day')
    }
    this.memberFlag = window.sessionStorage.getItem('member')
  },
  mounted () {
    this.getBenchAccounted()
    this.getRate()
    this.userRisk = this.$parameterConfig.p_risklevel[this.$commonJs.getCookie('u_risk')]
  },
  methods: {
    // 获取组合相关协议
    getBenchAccounted () {
      this.$http.post(this.$apiPath.groupDetailList, {
        combinationcode: this.combinationBuyForm.type,
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {
          this.agreementLists = res.data.data.groupDetail
        }
      })
    },
    // 风险揭示书和客户维护费
    agreementClick (val, fname) {
      const { href } = this.$router.resolve({
        name: fname,
        query: {
          fundcode: val
        }
      })
      window.open(href, '_blank')
    },
    // 风险测试
    getFunc (val) {
      window.sessionStorage.setItem('riskFlag', val)
    },
    // 费率
    getRate () {
      this.$http.post(this.$apiPath.selectFree, {
        id: this.$commonJs.getrate(this.combinationBuyForm.type)
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result && result[0]) {
          this.rate = result[0].purchaseRates
        }
      })
    },
    // 获取curAssetTansn
    async getGroupDetailList () {
      await this.$http.post(this.$apiPath.groupDetailList, {
        combinationcode: this.combinationBuyForm.type,
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result && result.groupDetail.length > 0) {
          // console.log(result.groupDetail)
          result.groupDetail.forEach(item => {
            this.curAssetgroupArr.push(item.comrate)
            this.curAssetTansnArr.push(item.tano)
          })
          // console.log(this.curAssetgroupArr, this.curAssetTansnArr);
        }

      }).catch(err => { })
    },
    // 展示组合名称
    async getGroupfundList () {
      await this.$http.post(this.$apiPath.groupfundList, {
        combinationcode: this.combinationBuyForm.type,
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result && result.groupfunds.length > 0) {
          // console.log(result.groupfunds);
          this.funddesc = result.groupfunds[0].funddesc
        }
      }).catch(err => { })
    },
    // 下单
    async getGroupBuy () {
      await this.$http.post(this.$apiPath.groupBuyFundDES, {
        fundcode: '040035',
        tano: '04',
        combinationcode: this.combinationBuyForm.type,  //
        paytype: 1,
        curAssetTansn: this.curAssetTansnArr.toString(),//8.2接口返回的值拼接而成
        channelid: this.combinationBuyForm.card.split('-')[1], //银行卡信息中获取
        moneyaccount: this.combinationBuyForm.card.split('-')[0],
        deviceId: '',
        applicationamount: this.combinationBuyForm.money,//下单金额
        ticketamount: this.reduceMoney,//优惠券金额
        passwd: this.$des.enString(this.combinationBuyForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        sessionId: this.$commonJs.getCookie('sessionid'),
        ticketids: this.ticketidStr.slice(0, -1),//优惠券id字符串用逗号拼接的值
        appnew: 1,//新个人中心标志
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code == "200") {
          const result = res.data.data
          if (result) {
            this.comappsheetno = result.comappsheetno
            this.liqdate = result.liqdate
            this.specification = result.specification
            this.specitimeress = result.specitimeress
            this.transactiondate = result.transactiondate
            this.successFlag = true
            // 成功页面
          } else {
            this.errorMsg = '下单失败'
            this.purchaseText = '确认购买'
          }
        } else if (res.data.code == "2004") {
          this.$message.error(res.data.message)
          this.purchaseText = '确认购买'
        } else {
          this.errorMsg = res.data.message
          this.purchaseText = '确认购买'
        }
      }).catch(err => { })
    },
    // 组合购买
    async getGroupBuyFundreadyPayStep () {
      if (this.successFlag) {
        await this.$http.post(this.$apiPath.groupBuyFundreadyPayStep, {
          applicationamount: this.combinationBuyForm.money,//下单金额
          appsheetserialno: this.comappsheetno,
          channelid: this.combinationBuyForm.card.split('-')[1], //银行卡信息中获取
          fundcode: "040035",
          fundname: this.funddesc,
          fundstatus: "",
          fundtype: "混合型",
          liqdate: this.liqdate,
          moneyaccount: this.combinationBuyForm.card.split('-')[0],
          passwd: this.$des.enString(this.combinationBuyForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
          sessionId: this.$commonJs.getCookie('sessionid'),
          tano: "04",
          appnew: 1,
        }).then(res => {
          // console.log(res);
          if (res.status !== 200) return
          if (res.data.data.code == "0000" && res.data.data.forward == "success") {
            this.stepDisplay = '2'
            this.$commonJs.amountWords(this.combinationBuyForm.money, 'capital')
          } else {
            this.stepDisplay = '3'
            this.wrongReason = '扣款失败'
          }
        }).catch(err => { })
      }

    },
    async getAxios () {
      await this.getGroupDetailList()
      await this.getGroupBuy()
      await this.getGroupfundList()
      await this.getGroupBuyFundreadyPayStep()
    },
    // 购买按钮
    purchaseClick () {
      this.combinationBuyBlur()
      if (this.riskFlag && !this.$commonJs.lm_checkFundLevel_jz(this.combinationBuyForm.type)) {//
        this.dialogVisable = true
      } else {
        if (this.combinationBuyForm.checked == false) {
          this.$message.error('请阅读精准理财服务协议')
        } else {
          this.$refs.combinationBuyFormRef.validate(valid => {
            if (!valid || this.waste) return
            // if (this.memberFlag == '0') {
            //   this.$message.error('您目前尚未是点财通会员，请先开通后购买')
            // } else
            if (this.combinationBuyForm.actuallyPaid == 0) {
              this.$message.error('实付金额要大于0才可购买，请重新选择！')
            } else {
              this.errorMsg = ''
              this.purchaseText = '处理中...'
              this.getAxios()
              // this.bankcardSigning()
            }
          })
        }
      }
    },
    // 银行卡签约
    bankcardSigning () {
      this.$http.post(this.$apiPath.checkBankInfoDES, {
        type: '1',
        depositacct: this.$des.enString(this.combinationBuyForm.card.split('-')[2], this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        idcode: this.$des.enString(Base64.decode(this.$commonJs.getCookie('u_id')), this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code == "200" && res.data.success) {
          // 已签约
          if (this.hfFlag ? res.data.data.hfstatus == "1" : res.data.data.fystatus == "1") {
            this.getAxios()
          } else {
            this.notSigned()
          }
        } else {
          // 未签约
          this.notSigned()
        }
      })
    },
    // 未签约
    notSigned () {
      var pass = this.$des.enString(this.combinationBuyForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
      if (pass == this.$commonJs.getCookie('Password')) {
        this.$router.push({
          name: 'bankCardVerification',
          params: {
            id: this.combinationBuyForm.card.split('-')[2],
            name: 'combinationBuy',
            data: this.combinationBuyForm
          }
        })
      } else {
        this.errorMsg = '密码输入错误'
        this.purchaseText = '确认购买'
      }
    },
    // 返回
    returnOne () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    // 资产详情
    detailsClick () {
      this.$router.push({
        name: 'combinationAssetsMessage',
        params: {
          value: 'combinationBuy'
        },
      })
    },
    //银行卡信息
    getslectedValue (val) {
      this.hfFlag = val.split('-')[3] == "1" ? true : false //汇付判断
      window.sessionStorage.setItem('card', val)
      this.combinationBuyForm.card = val
      this.SingleDealLimit = val.split('-')[4]
      this.SingleDayLimit = val.split('-')[5]
      window.sessionStorage.setItem('deal', val.split('-')[4])
      window.sessionStorage.setItem('day', val.split('-')[5])
    },
    //立减券
    reduceCouponChange (val) {
      // console.log(val);
      this.reduceMoney = 0
      this.ticketidStr = ''
      val.forEach(item => {
        this.reduceMoney += item.split(',')[1].split('元')[0] - 0
        this.ticketidStr += item.split(',')[0] + ','
      })
      // console.log(this.reduceMoney)
      if (this.combinationBuyForm.money < this.reduceMoney) {
        this.waste = true
        this.combinationBuyForm.actuallyPaid = 0
      } else {
        this.waste = false
        this.combinationBuyForm.actuallyPaid = this.combinationBuyForm.money - this.reduceMoney
      }
    },
    // 满减券
    fullReduceCouponChange (val) {
      this.reduceMoney = val.split(',')[1].split('减')[1] - 0
      this.ticketidStr = val.split(',')[0] + ','
      this.minFull = val.split(',')[1].split('减')[0].split('满')[1] - 0
      if (this.combinationBuyForm.money < this.minFull) {
        this.waste = true
        this.wasteText = '优惠券无法使用，请查看最低使用金额！'
      } else {
        if (this.combinationBuyForm.money < this.reduceMoney) {
          this.waste = true
          this.combinationBuyForm.actuallyPaid = 0
        } else {
          this.waste = false
          this.combinationBuyForm.actuallyPaid = this.combinationBuyForm.money - this.reduceMoney
        }
      }
    },
    couponChange () {
      this.reduceMoney = 0
      this.combinationBuyForm.actuallyPaid = this.combinationBuyForm.money
      this.ticketidStr = ''
      this.waste = false
    },
    // 购买金额
    combinationBuyInput () {
      // 费率
      this.cost = parseFloat((this.rate / 100) * (this.combinationBuyForm.money - 0)).toFixed(2)
      this.cost = (this.cost > 0) ? this.cost : '0.00'
      if (this.combinationBuyForm.money < this.minFull) {
        this.waste = true
        this.wasteText = '优惠券无法使用，请查看最低使用金额！'
      } else {
        // 优惠券
        if (this.combinationBuyForm.money < this.reduceMoney) {
          this.waste = true
          this.combinationBuyForm.actuallyPaid = 0
        } else {
          this.waste = false
          this.combinationBuyForm.actuallyPaid = this.combinationBuyForm.money - this.reduceMoney
        }
        this.combinationBuyForm.money < this.reduceMoney ? this.waste = true : this.waste = false
      }


    },
    combinationBuyBlur () {
      this.$refs.combinationBuyFormRef.validateField('money', (err) => {
        this.rateShow = err != '' ? false : true
      })
    },
    comNameChange (val) {
      this.riskFlag = true
      this.combinationBuyForm.type = val
      this.getBenchAccounted()
    },
    severClick () {
      this.$router.push({
        name: 'severAgreement',
        params: {
          pathName: 'combinationBuy'
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>
.read {
  width: 457px;
  line-height: 24px;
}
.valid {
  background: transparent;
  color: #246ead;
}
.riskText {
  font-size: 16px;
  margin-top: 20px;
}
</style>